import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankSensorType = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankSensorType },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldOptions = [
    'Pressure Submersible',
    'Pressure External',
    'Float (Fuel Only)'
  ];
  const fieldHasError = error && !dataField.valueTankSensorType;

  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankSensorType}
        items={radioItems}
        checkedId={dataField.valueTankSensorType || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankSensorType: value
        })}
        name="tank-sensor-type"
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      <Spacer space={2} />
    </>
  );
};

TankSensorType.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankSensorType;
